import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "app-toolbar py-3 py-lg-6" }
const _hoisted_2 = { class: "app-container d-flex flex-stack" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "page-title d-flex flex-column justify-content-center flex-wrap me-3" }, null, -1)
const _hoisted_4 = { class: "d-flex gap-4" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "svg-icon svg-icon-2 svg-icon-gray-600" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "app-content flex-column-fluid" }
const _hoisted_10 = { class: "d-flex flex-column flex-xl-row" }
const _hoisted_11 = { class: "flex-column flex-lg-row-auto w-100 w-xl-350px mb-10" }
const _hoisted_12 = { class: "card mb-5 mb-xl-8" }
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "d-flex justify-content-end mb-4" }
const _hoisted_15 = { class: "d-flex flex-center flex-column mb-5" }
const _hoisted_16 = { class: "fs-3 text-gray-800 fw-bold mb-1" }
const _hoisted_17 = { class: "d-flex flex-row" }
const _hoisted_18 = {
  key: 0,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-2 fw-bold counted" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-6 text-gray-400" }, " quantityItems ")
], -1)
const _hoisted_21 = {
  key: 1,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 mb-3"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-2 fw-bold counted" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-6 text-gray-400" }, "total")
], -1)
const _hoisted_24 = {
  class: "d-flex flex-stack fs-4 py-3 collapsible cursor-pointer rotate",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_customer_view_details"
}
const _hoisted_25 = { class: "fw-bold" }
const _hoisted_26 = { class: "ms-2 rotate-180" }
const _hoisted_27 = { class: "svg-icon svg-icon-1" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_29 = {
  id: "kt_customer_view_details",
  class: "collapse show"
}
const _hoisted_30 = { class: "py-5 fs-6" }
const _hoisted_31 = { class: "fw-bold" }
const _hoisted_32 = { class: "text-gray-600" }
const _hoisted_33 = { class: "fw-bold mt-5" }
const _hoisted_34 = { class: "text-gray-600" }
const _hoisted_35 = { class: "fw-bold mt-5" }
const _hoisted_36 = { class: "text-gray-600" }
const _hoisted_37 = { class: "fw-bold mt-5" }
const _hoisted_38 = { class: "text-gray-600" }
const _hoisted_39 = { class: "fw-bold mt-5" }
const _hoisted_40 = { class: "text-gray-600" }
const _hoisted_41 = { class: "fw-bold mt-5" }
const _hoisted_42 = { class: "text-gray-600" }
const _hoisted_43 = { class: "fw-bold mt-5" }
const _hoisted_44 = { class: "text-gray-600" }
const _hoisted_45 = { class: "flex-lg-row-fluid ms-lg-15" }
const _hoisted_46 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold mb-8" }
const _hoisted_47 = { class: "nav-item" }
const _hoisted_48 = { class: "nav-item" }
const _hoisted_49 = { class: "tab-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            disabled: _ctx.loading,
            class: "btn btn-secondary align-self-center text-gray-600",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
          }, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr063.svg" })
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.backToList")), 1)
          ], 8, _hoisted_5),
          (_ctx.baseData.status === _ctx.entityStatus.Deactivated)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                disabled: _ctx.loading,
                class: "btn btn-primary align-self-center",
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.activateThisEntity && _ctx.activateThisEntity(...args)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("kyc.actions.activate")), 1)
              ], 8, _hoisted_7))
            : _createCommentVNode("", true),
          (_ctx.baseData.status === _ctx.entityStatus.Activated)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                disabled: _ctx.loading,
                class: "btn btn-primary align-self-center",
                type: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deactivateThisEntity && _ctx.deactivateThisEntity(...args)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("kyc.actions.deactivate")), 1)
              ], 8, _hoisted_8))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                (_ctx.baseData.status)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass([_ctx.getStatus(_ctx.baseData.status).value.color, "badge"])
                    }, _toDisplayString(_ctx.baseData.status_text), 3))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.getName == " " ? "--" : _ctx.getName), 1),
                _createElementVNode("div", _hoisted_17, [
                  (0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createVNode(_component_el_popover, {
                          placement: "top",
                          width: "auto",
                          trigger: "hover",
                          "popper-class": "price-popover"
                        }, {
                          reference: _withCtx(() => [
                            _hoisted_20
                          ]),
                          default: _withCtx(() => [
                            _hoisted_19
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createVNode(_component_el_popover, {
                          placement: "top",
                          width: "auto",
                          trigger: "hover",
                          "popper-class": "price-popover"
                        }, {
                          reference: _withCtx(() => [
                            _hoisted_23
                          ]),
                          default: _withCtx(() => [
                            _hoisted_22
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("kyc.list.details")), 1),
                _createElementVNode("span", _hoisted_26, [
                  _createElementVNode("span", _hoisted_27, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr072.svg" })
                  ])
                ])
              ]),
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("kyc.list.entityId")), 1),
                  _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$route.params.id), 1),
                  _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t("kyc.information.common.tel")), 1),
                  _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.baseData.area_code ? "+" + _ctx.baseData.area_code + " " : "") + _toDisplayString(_ctx.baseData.telephone ? _ctx.baseData.telephone : "--"), 1),
                  _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("kyc.information.contactInformation.email")), 1),
                  _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.baseData.email || "--"), 1),
                  _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("kyc.information.contactInformation.address")), 1),
                  _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.baseData.address1 || _ctx.baseData.address2 || "--"), 1),
                  _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t("kyc.information.contactInformation.zipCode")), 1),
                  _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.baseData.postcode || "--"), 1),
                  _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t("kyc.information.contactInformation.country")), 1),
                  _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.baseData.country || "--"), 1),
                  _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("kyc.information.contactInformation.city")), 1),
                  _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.baseData.city || "--"), 1)
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("ul", _hoisted_46, [
            _createElementVNode("li", _hoisted_47, [
              _createVNode(_component_router_link, {
                to: _ctx.goPath + '/' + _ctx.$route.params.id + '/information',
                "active-class": "active",
                class: "nav-link text-active-primary me-6",
                replace: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("kyc.navigation.information")), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_48, [
              _createVNode(_component_router_link, {
                to: _ctx.goPath + '/' + _ctx.$route.params.id + '/historical-information',
                "active-class": "active",
                class: "nav-link text-active-primary me-6",
                replace: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("kyc.navigation.historicalInformation")), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createVNode(_component_router_view, {
              baseData: _ctx.baseData,
              loading: _ctx.loading,
              onGetFormData: _ctx.getFormInfo
            }, null, 8, ["baseData", "loading", "onGetFormData"])
          ])
        ])
      ])
    ])
  ], 64))
}